import { Check } from "lucide-react";
import { DIFFERENTIATORS, IMAGES } from "@/data";
import Reveal from "@/components/landing/Reveal";

export const WhyChoose = () => (
  <section
    id="why"
    data-testid="why-section"
    className="bg-cloud py-24 md:py-32"
  >
    <div className="max-w-[1440px] mx-auto px-5 md:px-12">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
        {/* Sticky left */}
        <div className="lg:sticky lg:top-28">
          <Reveal>
            <span className="font-display uppercase tracking-[0.2em] text-gold text-sm font-semibold">
              03 — Why Almeida's
            </span>
            <h2 className="mt-4 font-display font-bold uppercase text-navy text-4xl md:text-6xl leading-[0.9] tracking-tight">
              Quality you can count on
            </h2>
            <p className="mt-5 font-body text-navy/60 text-lg max-w-md">
              We earn trust the honest way — showing up, doing great work, and
              standing behind every job we finish.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-10 bg-navy rounded-2xl p-7 max-w-md" data-testid="trust-statement">
              <p className="font-display text-white text-xl md:text-2xl leading-snug tracking-tight">
                One partner for everything — hassle-free, on time, and
                <span className="text-gold"> guaranteed</span>.
              </p>
              <p className="mt-3 font-body text-white/70 text-sm">
                Licensed, insured and family-owned right here in the Charlotte metro.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.2}>
            <img
              src={IMAGES.about}
              alt="Modern home exterior remodel with new siding in the Charlotte metro"
              loading="lazy"
              width="1400"
              height="933"
              className="mt-8 rounded-2xl w-full h-56 object-cover hidden lg:block"
            />
          </Reveal>
        </div>

        {/* Checklist */}
        <div className="divide-y divide-navy/10 border-t border-navy/10">
          {DIFFERENTIATORS.map((d, i) => (
            <Reveal key={d} delay={i * 0.05}>
              <div className="flex items-center gap-5 py-6 group" data-testid={`differentiator-${i}`}>
                <span className="shrink-0 w-11 h-11 rounded-full bg-gold flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <Check size={22} className="text-navy-dark" strokeWidth={3} />
                </span>
                <span className="font-display font-semibold text-navy text-xl md:text-2xl tracking-tight">
                  {d}
                </span>
                <span className="ml-auto font-display text-navy/15 text-2xl font-bold">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default WhyChoose;
